'use strict';exports.__esModule = true;exports.deleteSavedSearchData = exports.toggleSmartAgentState = exports.loadSavedSearchData = exports.saveSearchData = exports.clearSearchData = exports.closeModal = exports.openModal = undefined;var _reduxAct = require('redux-act');
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxLoop = require('redux-loop');
var _services = require('../../../src/services');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise,batch = _reduxLoop.Effects.batch;

var openModal = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/OPEN_MODAL');
var closeModal = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/CLOSE_MODAL');
var saveSearchData = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/SAVE_SEARCH');

var clearSearchData = (0, _reduxAct.createAction)('/CLEAR_SEARCH_LOCATION/SAVE_SEARCH');

var createSmartAgent = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/CRATE_SMART_AGENT');
var saveSearchDataSuccess = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/SAVE_SEARCH_SUCCESS');
var saveSearchDataError = (0, _reduxAct.createAction)('/SAVE_SEARCH_LOCATION/SAVE_SEARCH_ERROR');

var loadSavedSearchData = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/LOAD_SAVED_SEARCH');
var loadSavedSearchDataSuccess = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/LOAD_SAVED_SEARCH_SUCCESS');
var loadSavedSearchDataError = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/LOAD_SAVED_SEARCH_ERROR');

var loadSmartAgentsSuccess = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/LOAD_SMART_AGENTS_SUCCESS');
var loadSmartAgentsError = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/LOAD_SMART_AGENTS_ERROR');

var toggleSmartAgentState = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/TOGGLE_SMART_AGENT_STATE');
var editSmartAgentsSuccess = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/EDIT_SMART_AGENTS_SUCCESS');
var editSmartAgentsError = (0, _reduxAct.createAction)('/LOAD_SEARCH_LOCATION/EDIT_SMART_AGENTS_ERROR');

var deleteSmartAgentsSuccess = (0, _reduxAct.createAction)('/DELETE_SEARCH_LOCATION/DELETE_SMART_AGENT_SUCCESS');

var deleteSavedSearchData = (0, _reduxAct.createAction)('/DELETE_SEARCH_LOCATION/DELETE_SAVED_SEARCH');
var deleteSavedSearchDataSuccess = (0, _reduxAct.createAction)('/DELETE_SEARCH_LOCATION/DELETE_SAVED_SEARCH_SUCCESS');
var deleteSavedSearchDataError = (0, _reduxAct.createAction)('/DELETE_SEARCH_LOCATION/DELETE_SAVED_SEARCH_ERROR');

var createAgent = function createAgent(_ref) {var data = _ref.data,token = _ref.token,email = _ref.email,locale = _ref.locale;return _axios2.default.
  post('/smart-agents/my', {
    property_search_id: (0, _get2.default)(data, 'data.id'),
    email: email,
    locale: locale || 'en' },
  {
    headers: { access_token: token } });};


var loadSavedSearchDataHandler = function loadSavedSearchDataHandler(token) {return _services.PropertySearchService.
  load(token).
  then(loadSavedSearchDataSuccess).
  catch(loadSavedSearchDataError);};

var loadSmartAgents = function loadSmartAgents(token) {return _axios2.default.get('/smart-agents/my', {
    headers: { access_token: token } }).

  then(loadSmartAgentsSuccess).
  catch(loadSmartAgentsError);};

var deleteSmartAgent = function deleteSmartAgent(_ref2) {var token = _ref2.token,agentId = _ref2.agentId;return _axios2.default.delete('/smart-agents/my/' + agentId, {
    headers: { access_token: token } }).

  then(function () {return deleteSmartAgentsSuccess(agentId);}).
  catch(editSmartAgentsError);};

var editSmartAgent = function editSmartAgent(_ref3) {var id = _ref3.id,token = _ref3.token,data = _ref3.data,email = _ref3.email;return (
  id ?
  _axios2.default.put('/smart-agents/my/' + id, data, { headers: { access_token: token } }) :
  createAgent({ email: email, token: token, data: data })).

  then(editSmartAgentsSuccess).
  catch(editSmartAgentsError);};

var deleteSavedSearchDataHandler = function deleteSavedSearchDataHandler(_ref4) {var id = _ref4.id,token = _ref4.token;return _services.PropertySearchService.
  delete(id, token).
  then(function () {return deleteSavedSearchDataSuccess(id);}).
  catch(deleteSavedSearchDataError);};

var initialState = {
  isOpen: false,
  submitting: false,
  submitted: false,
  loading: false,
  loaded: false,
  data: [],
  smartAgents: [],
  error: null };


var handleOpenModal = function handleOpenModal(state) {return Object.assign({},
  state, {
    isOpen: true });};


var handleCloseModal = function handleCloseModal(state) {return Object.assign({},
  state, {
    isOpen: false });};


var handleCreateSmartAgent = function handleCreateSmartAgent(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true,
    submitted: false,
    error: null }),
  promise(createAgent, data));};


var handleToggleSmartAgentState = function handleToggleSmartAgentState(state, payload) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true,
    error: null }),
  promise(editSmartAgent, payload));};


var handleLoadSearchData = function handleLoadSearchData(state, _ref5) {var token = _ref5.token;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    error: null }),
  batch([
  promise(loadSavedSearchDataHandler, token),
  promise(loadSmartAgents, token)]));};


var uploadSearchData = function uploadSearchData(data, token, userEmail, locale) {return _services.PropertySearchService.
  create(_services.PropertySearchService.generateRequestData(data), token).
  then(function (resp) {return createAgent({ data: resp, token: token, email: userEmail, locale: locale });}).
  then(saveSearchDataSuccess).
  then(function () {return loadSavedSearchDataHandler(token);}).
  catch(saveSearchDataError);};

var handleSaveSearchData = function handleSaveSearchData(state, _ref6) {var data = _ref6.data,token = _ref6.token,userEmail = _ref6.userEmail,locale = _ref6.locale;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true,
    submitted: false,
    error: null }),
  promise(uploadSearchData, data, token, userEmail, locale));};

var handleDeleteSearchData = function handleDeleteSearchData(state, _ref7) {var id = _ref7.id,token = _ref7.token,agentId = _ref7.agentId;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    deleting: true,
    deleted: false,
    error: null }),
  agentId ?
  batch([
  promise(deleteSavedSearchDataHandler, { id: id, token: token }),
  promise(editSmartAgent, { id: agentId, token: token, data: { active: false } }),
  promise(deleteSmartAgent, { agentId: agentId, token: token })]) :

  promise(deleteSavedSearchDataHandler, { id: id, token: token }));};


var handleSaveSearchDataSuccess = function handleSaveSearchDataSuccess(state) {return Object.assign({},
  state, {
    isOpen: false,
    submitting: false,
    submitted: true,
    error: null });};


var handleSaveSearchDataError = function handleSaveSearchDataError(state, _ref8) {var error = _ref8.error;return Object.assign({},
  state, {
    submitting: false,
    submitted: false,
    error: error });};


var handleLoadSearchDataSuccess = function handleLoadSearchDataSuccess(state, _ref9) {var data = _ref9.data;return Object.assign({},
  state, {
    data: data.map(_services.PropertySearchService.generateRouteData),
    isOpen: false,
    loading: false,
    loaded: true,
    error: null });};


var handleLoadSearchDataError = function handleLoadSearchDataError(state, _ref10) {var error = _ref10.error;return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });};


var handleLoadSmartAgentsSuccess = function handleLoadSmartAgentsSuccess(state, _ref11) {var data = _ref11.data;return Object.assign({},
  state, {
    smartAgents: data.data,
    isOpen: false,
    loading: false,
    loaded: true,
    error: null });};


var handleLoadSmartAgentsError = function handleLoadSmartAgentsError(state, _ref12) {var error = _ref12.error;return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });};


var handleEditSmartAgentsSuccess = function handleEditSmartAgentsSuccess(state, _ref13) {var data = _ref13.data;return Object.assign({},
  state, {
    smartAgents: [].concat(state.smartAgents.filter(function (agent) {return agent.id !== data.id;}), [Object.assign({}, data)]),
    isOpen: false,
    loading: false,
    loaded: true,
    error: null });};


var handleEditSmartAgentsError = function handleEditSmartAgentsError(state, _ref14) {var error = _ref14.error;return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });};


var handleDeleteSearchDataSuccess = function handleDeleteSearchDataSuccess(state, id) {
  var updatedData = state.data.filter(function (_ref15) {var searchId = _ref15.id;return searchId !== id;});

  return Object.assign({},
  state, {
    data: updatedData,
    isOpen: false,
    deleting: false,
    deleted: true,
    error: null });

};

var handleDeleteSmartAgentsSuccess = function handleDeleteSmartAgentsSuccess(state, id) {
  var updatedData = state.smartAgents.filter(function (_ref16) {var agentId = _ref16.id;return agentId !== id;});

  return Object.assign({},
  state, {
    smartAgents: updatedData,
    isOpen: false,
    deleting: false,
    deleted: true,
    error: null });

};

var handleDeleteSearchDataError = function handleDeleteSearchDataError(state, _ref17) {var error = _ref17.error;return Object.assign({},
  state, {
    deleting: false,
    deleted: false,
    error: error });};


var handleClearSearchData = function handleClearSearchData() {return Object.assign({},
  initialState);};


var saveSearchLocation = (0, _reduxAct.createReducer)(function (on) {
  on(openModal, handleOpenModal);
  on(closeModal, handleCloseModal);
  on(saveSearchData, handleSaveSearchData);
  on(createSmartAgent, handleCreateSmartAgent);
  on(saveSearchDataSuccess, handleSaveSearchDataSuccess);
  on(saveSearchDataError, handleSaveSearchDataError);
  on(loadSavedSearchData, handleLoadSearchData);
  on(loadSavedSearchDataSuccess, handleLoadSearchDataSuccess);
  on(loadSavedSearchDataError, handleLoadSearchDataError);
  on(deleteSavedSearchData, handleDeleteSearchData);
  on(deleteSavedSearchDataSuccess, handleDeleteSearchDataSuccess);
  on(deleteSavedSearchDataError, handleDeleteSearchDataError);
  on(deleteSmartAgentsSuccess, handleDeleteSmartAgentsSuccess);
  on(loadSmartAgentsSuccess, handleLoadSmartAgentsSuccess);
  on(loadSmartAgentsError, handleLoadSmartAgentsError);
  on(editSmartAgentsSuccess, handleEditSmartAgentsSuccess);
  on(editSmartAgentsError, handleEditSmartAgentsError);
  on(toggleSmartAgentState, handleToggleSmartAgentState);
  on(clearSearchData, handleClearSearchData);
}, initialState);exports.


openModal = openModal;exports.
closeModal = closeModal;exports.
clearSearchData = clearSearchData;exports.
saveSearchData = saveSearchData;exports.
loadSavedSearchData = loadSavedSearchData;exports.
toggleSmartAgentState = toggleSmartAgentState;exports.
deleteSavedSearchData = deleteSavedSearchData;exports.default =


saveSearchLocation;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/saveSearchLocation.js
// module id = 285
// module chunks = 0